import { StyledTableCell, StyledTableRow } from "@/style/theme/StyledTable";
import { Skeleton } from "@mui/material";

export function GenericTableSkeleton({ rows, cols }: { rows: number; cols: number }) {

  return <>
    {[...Array(rows)].map((_, i) => {
      return <StyledTableRow key={i}>
        {[...Array(cols)].map((_, j) => {
          return <StyledTableCell key={j} align="center">
            <Skeleton/>
          </StyledTableCell>;
        })}
      </StyledTableRow>;
    })}
  </>;
}